import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useButtonCookie } from '../../form_cookie';

function SectionSubtype({
  subtype, setSubtype, requestType, errorText, handleLogistics, editMode,
}) {
  const [sourceRequestSubtype, setSourceRequestSubtype] = useButtonCookie('source-request-subtype', '');
  const [, setSourceRequestLogistics] = useButtonCookie('source-request-logistics', []);

  useEffect(() => {
    if (!editMode) {
      setSubtype(sourceRequestSubtype);
    }
  }, [sourceRequestSubtype, editMode, setSubtype]);

  if (requestType === 'story_ideas') {
    return null;
  }

  const updateSubType = (selectedSubType) => {
    // Reset logisticsDetails if user clicks on new subtype
    // setLogisticsDetails([]); // TODO
    setSubtype(selectedSubType);

    if (!editMode) {
      setSourceRequestSubtype(selectedSubType);
      setSourceRequestLogistics([]);
    }

    handleLogistics(true, false);
  };

  const selectedSubtype = editMode ? subtype : sourceRequestSubtype;
  const humanizeString = (str) => str.replace('_', '/');

  const renderSubTypeButtons = () => {
    let options;
    switch (requestType) {
      case 'speakers':
        options = [
          { text: 'webinar', icon: <i className="fa-solid fa-circle-video" /> },
          { text: 'lecture', icon: <i className="fa-solid fa-podium" /> },
          { text: 'conference', icon: <i className="fa-solid fa-screen-users" /> },
        ];
        break;
      case 'guests':
        options = [
          { text: 'radio_podcast', icon: <i className="fa-solid fa-microphone" /> },
          { text: 'video_broadcast', icon: <i className="fa-solid fa-video" /> },
        ];
        break;
      case 'man_on_the_street':
        options = [
          { text: 'online_print', icon: <i className="fa-solid fa-newspaper" /> },
          { text: 'radio_podcast', icon: <i className="fa-solid fa-microphone" /> },
          { text: 'video_broadcast', icon: <i className="fa-solid fa-video" /> },
        ];
        break;
      default: // also 'experts'
        options = [
          { text: 'online_print', icon: <i className="fa-solid fa-newspaper" /> },
          { text: 'radio_podcast', icon: <i className="fa-solid fa-microphone" /> },
          { text: 'video_broadcast', icon: <i className="fa-solid fa-video" /> },
          { text: 'event', icon: <i className="fa-solid fa-calendar" /> },
        ];
    }

    return options.map((option) => (
      <button
        key={option.text}
        type="button"
        className={`btn btn-outline-primary text-uppercase me-2 mb-2 ${
          selectedSubtype === option.text ? ' active ' : null
        }`}
        style={{
          borderWidth: '2px',
          letterSpacing: '2px',
        }}
        onClick={() => updateSubType(option.text)}
      >
        {option.icon}
        <span style={{ marginLeft: '8px' }}>{humanizeString(option.text)}</span>
      </button>
    ));
  };

  return (
    <div className="section-subtype">
      {renderSubTypeButtons()}
      {errorText && <p className="form-text d-block text-danger fw-bold" style={{ fontSize: '1rem' }}>{errorText}</p>}
    </div>
  );
}

SectionSubtype.propTypes = {
  subtype: PropTypes.string,
  setSubtype: PropTypes.func.isRequired,
  requestType: PropTypes.string.isRequired,
  errorText: PropTypes.string,
  handleLogistics: PropTypes.func.isRequired,
  editMode: PropTypes.bool,
};

SectionSubtype.defaultProps = {
  subtype: 'experts',
  errorText: null,
  editMode: false,
};

export default SectionSubtype;
